import config from "../config";
import services from "../services/HttpService";
export default {
    getEquipmentTypes(userToken,type) {
        //console.log('hi this is calling from common service');
        let response = {
            "equipment_types":[],
            "equipment_type_codes":[]
        }
        return new Promise((resolve, reject) => {
            services.get("equipments/list", {
                'Authorization': 'Bearer ' + userToken
            })
            .then(res => {
                res.data.data.map(async function (data) {
                    let newArr = {};
                    newArr.name = data.name;
                    newArr.code = data.code;
                    response.equipment_type_codes.push(data.code);
                    await response.equipment_types.push(newArr);
                });
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/CommonService.js